import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const wosCategoryApi = generateNomenApi(`/nomen/wos-category`);

export const wosCategoryOptions = generateNomenOptions('wos-category', wosCategoryApi);
